import React, { useState } from 'react'
import {
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
} from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form'
import {
  FirebaseConfigKey,
  FirebaseService,
} from '../../services/FirebaseService'
import { KeyboardDatePicker } from '@material-ui/pickers'
import BordereauxRunButton from './RunBordereauxButton'
import { yupResolver } from '@hookform/resolvers/yup'
import insuranceApi from '../../api/insurance.api'
import * as yup from 'yup'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'

export const schema = yup
  .object()
  .shape({
    to: yup.date().typeError('Required').required('Required'),
    from: yup.date().typeError('Required').required('Required'),
  })
  .required()
const BordereauxRun = () => {
  const [loading, setLoading] = useState(false)
  const { control, handleSubmit, errors } = useForm({
    mode: 'onBlur',
    defaultValues: { to: null, from: null },
    resolver: yupResolver(schema),
  })

  const loadingProps = {
    startIcon: loading ? <CircularProgress color="gray" /> : undefined,
    disabled: loading,
  }

  const submit = async (data) => {
    console.log(data)
    setLoading(true)
    EventEmitterService.dispatch(EventKey.ShowLoader)
    const includePriceReport = !!data.include_price_report
    const res = await insuranceApi.runBordereaux(
      data.from,
      data.to,
      includePriceReport
    )
    EventEmitterService.dispatch(EventKey.DismissLoader)
    setLoading(false)
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(res.data)
    link.download = 'bordereaux.csv'
    link.click()
    link.remove()
  }

  return (
    <Container className="margin-top-basic">
      <form onSubmit={handleSubmit(submit)}>
        <Grid container alignItems="center" justifyContent="center" spacing={2}>
          <Grid item>
            <Controller
              name="from"
              control={control}
              render={({ ref, ...rest }) => (
                <KeyboardDatePicker
                  placeholder="MM/DD/YYYY"
                  openTo="year"
                  label="From"
                  views={['year', 'month', 'date']}
                  format={FirebaseService.getValue(
                    FirebaseConfigKey.LONG_DATE_FORMAT
                  )}
                  error={!!errors.from}
                  inputVariant="outlined"
                  helperText={errors.from?.message}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  {...rest}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Controller
              name="to"
              control={control}
              render={({ ref, ...rest }) => (
                <KeyboardDatePicker
                  placeholder="MM/DD/YYYY"
                  openTo="year"
                  label="To"
                  views={['year', 'month', 'date']}
                  format={FirebaseService.getValue(
                    FirebaseConfigKey.LONG_DATE_FORMAT
                  )}
                  error={!!errors.to}
                  inputVariant="outlined"
                  helperText={errors.to?.message}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  {...rest}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Controller
              name="include_price_report"
              label="Include Price Report"
              control={control}
              render={({ onChange: paramsOnChange, ...params }) => (
                <FormControlLabel
                  label="Include Price Report"
                  control={
                    <Checkbox
                      {...params}
                      checked={params.value}
                      color="primary"
                      onChange={(e, data) => {
                        paramsOnChange(e.target.checked)
                      }}
                    />
                  }
                />
              )}
            />
          </Grid>
          <Grid item>
            <BordereauxRunButton
              type="submit"
              {...loadingProps}
              style={{ margin: 0 }}>
              Run Bordereaux
            </BordereauxRunButton>
          </Grid>
        </Grid>
      </form>
    </Container>
  )
}

export default BordereauxRun
